// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1uud5","inputWrap":"Table_inputWrap__3BtBf","col":"Table_col__2lnUs","bmiTooltip":"Table_bmiTooltip__3MpKh"};